import { Component, OnInit } from '@angular/core';
import { ConfigService } from 'src/app/_LOGIC/__config/config.service';
import { ShopifyService } from 'src/app/_LOGIC/__shopify/shopify.service';

@Component({
  selector: 'app-banner-cta-full-width',
  templateUrl: './banner-cta-full-width.component.html',
  styleUrls: ['./banner-cta-full-width.component.css']
})

export class BannerCtaFullWidthComponent implements OnInit {

  constructor(private shopifyService: ShopifyService,private configService: ConfigService) { }

  ngOnInit(): void {
  }

  buyProductSimple(myVariantLabel){
    let orderObject = {
            'productVariantId': this.configService.findVariantBy(this.configService.getStockProductsFromShopify(),'variantLabel', myVariantLabel).variantId
    };
    this.shopifyService.buyProduct(orderObject);
  }

}
